import { SxProps, Theme } from '@mui/material';

interface IStyles {
  container: SxProps<Theme>;
  formControlLabel: SxProps<Theme>;
}

export const styles: IStyles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: '100%',
    alignItems: 'center',
    gap: 2,
    height: 45,
  },
  formControlLabel: {
    alignItems: 'center',
    '.MuiFormControlLabel-label': {
      paddingTop: '0 !important',
    },
  },
};
